var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-nav-config borderPadding" },
    [
      _c(
        "div",
        { staticClass: "tab-switcher" },
        _vm._l(_vm.configData.list, function (tab, tIndex) {
          return _c(
            "div",
            {
              key: tIndex,
              staticClass: "tab-btn",
              class: { active: _vm.currentTab === tIndex },
              on: {
                click: function ($event) {
                  return _vm.switchTab(tIndex)
                },
              },
            },
            [_vm._v(" " + _vm._s(tab.value) + " ")]
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "menu-list mt20" },
        [
          _c(
            "draggable",
            {
              staticClass: "dragArea list-group",
              attrs: {
                list: _vm.currentMenuArray,
                group: "customNav",
                handle: ".move-icon",
              },
            },
            _vm._l(_vm.currentMenuArray, function (item, index) {
              return _c("div", { key: index, staticClass: "menu-item" }, [
                _c("div", { staticClass: "move-icon" }, [
                  _c("span", { staticClass: "iconfont icon-tuozhuaidian" }),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "img-box",
                    on: {
                      click: function ($event) {
                        return _vm.modalPicTap(item, index)
                      },
                    },
                  },
                  [
                    item.img
                      ? _c("img", { attrs: { src: item.img, alt: "" } })
                      : _c("div", { staticClass: "upload-box" }, [
                          _c("i", {
                            staticClass: "el-icon-camera-solid",
                            staticStyle: { "font-size": "30px" },
                          }),
                        ]),
                  ]
                ),
                _c("div", { staticClass: "item-info" }, [
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "label" }, [_vm._v("标题")]),
                    _c(
                      "div",
                      { staticClass: "input-wrap" },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "small",
                            placeholder: "选填，不超过4个字",
                            maxlength: "4",
                          },
                          model: {
                            value: item.info[0].value,
                            callback: function ($$v) {
                              _vm.$set(item.info[0], "value", $$v)
                            },
                            expression: "item.info[0].value",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "label" }, [_vm._v("链接")]),
                    _c(
                      "div",
                      { staticClass: "input-wrap" },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: {
                              size: "small",
                              value: _vm.getLinkValue(item),
                              placeholder: "请选择链接",
                              readonly: "",
                            },
                            on: {
                              focus: function ($event) {
                                return _vm.getLink(index)
                              },
                            },
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                slot: "append",
                                icon: "el-icon-arrow-right",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getLink(index)
                                },
                              },
                              slot: "append",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "info-row" },
                    [
                      _c("span", { staticClass: "label" }, [_vm._v("状态")]),
                      _c("el-switch", {
                        attrs: {
                          "active-value": true,
                          "inactive-value": false,
                          "active-text": "显示",
                          "inactive-text": "隐藏",
                        },
                        model: {
                          value: item.status,
                          callback: function ($$v) {
                            _vm.$set(item, "status", $$v)
                          },
                          expression: "item.status",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "delete-btn",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.deleteItem(index)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-error",
                      staticStyle: { "font-size": "26px" },
                    }),
                  ]
                ),
              ])
            }),
            0
          ),
        ],
        1
      ),
      _c("linkaddress", { ref: "linkaddres", on: { linkUrl: _vm.linkUrl } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }